/**
* Featured Treatment JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Treatment component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-treatment',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-treatment__inner-content' ).each( function( index ) {
        if ( index === 1 ) {
          $( this ).addClass( 'lg:ml-auto' );
        }
      } );

      $( '.featured-treatment__title-text' ).each( function( index ) {
        if ( index === 0 ) {
          $( this ).addClass( 'pr-gutter-full' );
        } else {
          $( this ).addClass( 'pl-gutter-full right-0 transform -translate-x-4' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-treatment', COMPONENT );
} )( app );
